// @flow

import React from 'react';

import { AppBanner } from '@zapier/services';
import { Query } from '@apollo/react-components'; // eslint-disable-line no-restricted-syntax

import appBannerQuery from './appBannerQuery';

type QueryResult = {
  data: ?{
    appImplementationById: {
      id: string,
      banner: 'beta' | 'by-invite' | 'deprecated' | 'premium',
    },
  },
};

type Props = {
  api: ?string,
};

const SmartAppBanner = (props: Props) => (
  <Query query={appBannerQuery} skip={!props.api} variables={{ id: props.api }}>
    {(result: QueryResult) => {
      const { data = {} } = result;
      const { appImplementationById } = data || {};

      if (!appImplementationById) {
        return null;
      }

      return <AppBanner banner={appImplementationById.banner} />;
    }}
  </Query>
);

export default SmartAppBanner;
